import React from 'react';
import { motion } from 'framer-motion';
import { FiYoutube, FiMic, FiAward, FiExternalLink } from 'react-icons/fi';
import { SiSpeakerdeck } from 'react-icons/si';

const talks = [
  {
    title: "Building Cross-Platform Mobile Apps with Flutter and PHP Backend",
    url: "https://www.youtube.com/watch?v=NCkuMs_td-U",
    thumbnail: "https://img.youtube.com/vi/NCkuMs_td-U/maxresdefault.jpg"
  },
  {
    title: "Speaking at Akwa Ibom Tech Week",
    url: "https://www.youtube.com/watch?v=rD3o8V3h770",
    thumbnail: "https://img.youtube.com/vi/rD3o8V3h770/maxresdefault.jpg"
  },
  {
    title: "Community Highlight / Short",
    url: "https://www.youtube.com/shorts/cbQeV4P1v68",
    thumbnail: "https://img.youtube.com/vi/cbQeV4P1v68/maxresdefault.jpg"
  }
];

const Advocacy = () => {
  return (
    <section id='advocacy' className='py-24 bg-[#040811] relative border-t border-slate-800/50'>
      <div className='max-w-7xl mx-auto px-6 lg:px-8 relative z-10'>
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="flex items-center justify-center space-x-3 mb-4">
            <FiMic className="text-4xl text-secondary" />
            <h2 className='text-3xl md:text-5xl font-bold text-white'>Advocacy & Talks</h2>
          </div>
          <div className="h-1 w-20 bg-gradient-to-r from-primary to-secondary mx-auto rounded-full"></div>
          <p className="text-slate-400 mt-6 max-w-2xl mx-auto">
            Passionate about sharing knowledge, building communities, and speaking at tech conferences across the globe.
          </p>
        </motion.div>
        
        {/* Talks Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {talks.map((talk, idx) => (
            <motion.div 
              key={idx}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: idx * 0.1 }}
              className="group relative bg-slate-800/30 border border-slate-700/50 rounded-2xl overflow-hidden hover:border-red-500/50 transition-colors backdrop-blur-sm"
            >
              <a href={talk.url} target="_blank" rel="noreferrer" className="block relative h-48 w-full overflow-hidden">
                <img 
                  src={talk.thumbnail} 
                  alt={talk.title} 
                  className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    // Fallback for shorts thumbnail or if maxresdefault is unavailable
                    e.target.src = `https://img.youtube.com/vi/${talk.url.split('/').pop().replace('watch?v=', '')}/hqdefault.jpg`;
                  }}
                />
                <div className="absolute inset-0 bg-slate-900/40 group-hover:bg-transparent transition-colors duration-300"></div>
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-12 bg-red-600 rounded-2xl flex items-center justify-center shadow-lg group-hover:scale-110 group-hover:bg-red-500 transition-all">
                    <FiYoutube className="text-white text-2xl" />
                  </div>
                </div>
              </a>
              <div className="p-5">
                <a href={talk.url} target="_blank" rel="noreferrer" className="text-lg font-bold text-white group-hover:text-red-400 transition-colors line-clamp-2">
                  {talk.title}
                </a>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Resources Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <motion.a
            href="https://speakerdeck.com/utibeetim"
            target="_blank"
            rel="noreferrer"
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex items-center space-x-6 bg-slate-800/30 border border-slate-700/50 p-8 rounded-3xl hover:border-secondary/50 transition-colors group"
          >
            <div className="w-16 h-16 bg-[#009287]/20 rounded-2xl flex items-center justify-center shrink-0">
              <SiSpeakerdeck className="text-3xl text-[#009287]" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-white group-hover:text-secondary transition-colors flex items-center gap-2">
                Presentation Slides <FiExternalLink className="text-lg opacity-0 group-hover:opacity-100 transition-opacity" />
              </h3>
              <p className="text-slate-400 mt-2">View all my technical presentation slides on SpeakerDeck.</p>
            </div>
          </motion.a>

          <motion.a
            href="https://linktr.ee/UtibeSE"
            target="_blank"
            rel="noreferrer"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            className="flex items-center space-x-6 bg-slate-800/30 border border-slate-700/50 p-8 rounded-3xl hover:border-primary/50 transition-colors group"
          >
            <div className="w-16 h-16 bg-[#39E09B]/20 rounded-2xl flex items-center justify-center shrink-0">
              <FiAward className="text-3xl text-[#39E09B]" />
            </div>
            <div>
              <h3 className="text-2xl font-bold text-white group-hover:text-primary transition-colors flex items-center gap-2">
                My Certifications <FiExternalLink className="text-lg opacity-0 group-hover:opacity-100 transition-opacity" />
              </h3>
              <p className="text-slate-400 mt-2">Check out my earned certifications and professional badges.</p>
            </div>
          </motion.a>
        </div>
      </div>
    </section>
  )
}

export default Advocacy;
